export default __webpack_public_path__ + "static/media/Banners_raceweekCanada_330x330.0319f620.jpg";